export default __webpack_public_path__ + "static/media/title-desktop-latam.7204cf4c.png";